import { Bounds } from "../types/bounds";
import { Site } from "../types/site";
import { getDistance } from "geolib";

/**
 * 現場の横幅、縦幅のうち最大値を計算する関数
 * @param {Site} site - 現場情報
 * @returns {number | undefined} 現場の最大幅（メートル単位）
 */
export const calcSiteMaxWidth = (site: Site): number | undefined => {
  const { westExtremity, eastExtremity, northExtremity, southExtremity } = site;

  const latDistance = getDistance(
    { latitude: northExtremity, longitude: westExtremity },
    { latitude: southExtremity, longitude: westExtremity },
  );

  const lngDistance = getDistance(
    { latitude: northExtremity, longitude: westExtremity },
    { latitude: northExtremity, longitude: eastExtremity },
  );

  if (latDistance === undefined || lngDistance === undefined) {
    return undefined;
  }

  return Math.max(latDistance, lngDistance);
};

/**
 * 現場に緯度経度の情報が格納されているかどうかを判定する関数
 * @param {Site} site - 現場情報
 * @returns {boolean} 緯度経度の情報が格納されているかどうか
 */
export const isSiteRegistered = (site: Site): boolean => {
  return (
    site.eastExtremity !== null && site.westExtremity !== null && site.northExtremity !== null && site.southExtremity !== null
  );
};

/**
 * 領域の緯度経度の値を現場オブジェクトから取得する関数
 * @param {Site} site - 現場情報
 * @returns {{ north: number; south: number; east: number; west: number }} 領域の緯度経度の値
 */
export const convertSiteToBound = (site: Site): Bounds => {
  return {
    north: site.northExtremity,
    south: site.southExtremity,
    west: site.westExtremity,
    east: site.eastExtremity,
  };
};

/**
 * 現場領域の中心座標を計算する関数
 * @param {Site} site - 現場情報
 * @returns {{ lat: number; lng: number }} 現場の中心座標
 */
export const calcSiteCenter = (site: Site): { lat: number; lng: number } => {
  return {
    lat: (site.northExtremity + site.southExtremity) / 2,
    lng: (site.eastExtremity + site.westExtremity) / 2,
  };
};
